import React from 'react';
import { logout } from '../utils/auth';
import './LogoutButton.css';

const LogoutButton = () => {
  return (
    <button className="logout-button" onClick={logout}>
      Logout
    </button>
  );
};

export default LogoutButton;

